import {
  removeSavedItems,
  SavedItems,
} from "@repo/apis/customers-saveditems-v3";
import { SavedItemsSdkMethod } from "../utils/method-initializer";

type PublicRemoveSavedItemsMethod = (params: {
  itemId: string;
}) => Promise<SavedItems>;
type RemoveSavedItemsMethod = SavedItemsSdkMethod<PublicRemoveSavedItemsMethod>;

export const removeSavedItemsInitializer: RemoveSavedItemsMethod =
  ({ state, getAuthHeaderPredicate, ...context }) =>
  async ({ itemId }) => {
    const savedItems = state.getSavedItemsState();

    try {
      await removeSavedItems({
        itemId,
        chameleonRequestInstance: context.chameleonRequestInstance,
        keyStoreDataversion: context.keyStoreDataversion,
        store: context.store,
        currency: context.currency,
        sizeSchema: context.sizeSchema,
        lang: context.lang,
        authHeader: await getAuthHeaderPredicate(),
        country: context.country,
        shop: context.shop,
      });

      const filteredProducts =
        savedItems?.savedItemProducts.filter((item) => item.id !== itemId) ||
        [];

      const updatedSavedItemsState: SavedItems = {
        itemCount: filteredProducts.length,
        savedItemProducts: filteredProducts,
        savedItemIds:
          savedItems?.savedItemIds.filter(({ id }) => id !== itemId) || [],
        isAnonymousCustomer: savedItems?.isAnonymousCustomer || true,
      };

      console.log("Updated saved items state:", updatedSavedItemsState);

      state.setSavedItemsState(updatedSavedItemsState);

      return updatedSavedItemsState;
    } catch (error) {
      console.error("Error removing saved items:", error);
      throw error;
    }
  };
